import { cn } from '@/lib/utils';

interface WizardStepNavProps {
  currentStep: number;
  totalSteps: number;
  stepLabels: string[];
  maxAccessibleStep: number;
  onStepClick?: (step: number) => void;
}

export const WizardStepNav = ({ currentStep, totalSteps, stepLabels, maxAccessibleStep, onStepClick }: WizardStepNavProps) => {
  return (
    <div className="flex items-center gap-0 px-6 py-4 border-b border-[#333] overflow-x-auto">
      {Array.from({ length: totalSteps }, (_, i) => {
        const step = i + 1;
        const isActive = step === currentStep;
        const isAccessible = step <= maxAccessibleStep;
        const isCompleted = step < currentStep;
        return (
          <div key={step} className="flex items-center">
            <button
              onClick={() => onStepClick?.(step)}
              disabled={!isAccessible}
              style={isActive ? { backgroundColor: '#C3D82E' } : {}}
              className={cn(
                'flex items-center gap-2 px-3 py-1.5 rounded text-sm whitespace-nowrap transition-colors',
                isActive ? 'text-[#1A1A1A] font-semibold' :
                isAccessible ? 'text-[#C3D82E] hover:text-[#D4E845] cursor-pointer' :
                'text-[#666] cursor-default'
              )}
            >
              <span className={cn(
                'inline-flex items-center justify-center w-5 h-5 rounded-full text-xs font-bold',
                isActive    ? 'bg-[#1A1A1A] text-[#C3D82E]' :
                isCompleted ? 'bg-[#C3D82E] text-[#1A1A1A]' :
                isAccessible ? 'bg-[#555] text-[#CCC]' :
                'bg-[#444] text-[#999]'
              )}>
                {isCompleted ? '✓' : step}
              </span>
              {stepLabels[i]}
            </button>
            {step < totalSteps && (
              <span className="mx-1 text-[#444] select-none">—</span>
            )}
          </div>
        );
      })}
    </div>
  );
};
